import React from 'react'

import { Typography } from '@telavita-core/react-design-kit'

import { CoreIcons } from 'components'

import * as S from './styles'

interface ResultNotFoundProps {
  iconName?: string
  iconHeight?: string
  iconWidth?: string
  title?: string
  text?: string
}

const ResultNotFound = ({
  iconName,
  iconHeight = '64px',
  iconWidth = '64px',
  title,
  text,
}: ResultNotFoundProps): JSX.Element => {
  return (
    <S.Container>    
      {iconName && (
        <CoreIcons
          fill={'#4b4b4b'}
          height={iconHeight}
          name={iconName}
          width={iconWidth}
        />
      )}

      <Typography variant='content1' weight='bolder' >{title}</Typography>
      <Typography variant='content2'>{text}</Typography>
    </S.Container>
  )
}

export default ResultNotFound
